<template>
  <LibraryLayout :title="'Conundrum Library'" :items="conundrums">
    <template slot="button">
      <v-btn v-if="authUser" @click="createConundrum" color="teal" dark class="elevation-0">
        <v-icon left>mdi-creation-outline</v-icon> Create Conundrum
      </v-btn>
      <v-btn v-else @click="go('LoginView')" color="teal" dark class="elevation-0">
        <v-icon left>mdi-lock-outline</v-icon> Create Conundrum
      </v-btn>
    </template>
    <template #card="{ item: c }">
      <v-card class="ma-2 pointer" width="300" @click="go('ConundrumPlayer', c.id)">
        <v-sheet color="grey lighten-4" height="200" class="d-flex align-center justify-center">
          <div class="pa-4 text-truncate-3 cal-sans-regular">{{ c.title || c.name }}</div>
        </v-sheet>
        <v-divider></v-divider>
        <div class="px-4 pt-4 cal-sans-regular font-size-20">{{ c.title || c.name }}</div>
        <div class="px-4 pb-4 pt-2 grey--text text--darken-1">{{ c.description }}</div>
      </v-card>
    </template>
  </LibraryLayout>
</template>

<script>
import { getDocs, collection, query, where } from 'firebase/firestore'
import { db } from '@/firebase/init'
import LibraryLayout from '@/layouts/Library.vue'

export default {
  name: 'ConundrumLibrary',

  components: { LibraryLayout },

  data() {
    return {
      conundrums: [],
      progress: 0,
    }
  },

  created() {
    this.loadConundrums()
  },

  methods: {
    async loadConundrums() {
      this.progress = 0
      this.conundrums = []
      const conundrumsRef = collection(db, 'conundrums')
      const q = query(conundrumsRef, where('state', '==', 'public'))
      const snapshot = await getDocs(q)
      snapshot.forEach((doc) => {
        let c = doc.data()
        c.id = doc.id
        this.conundrums.push(c)
      })
      this.progress = 100
    },

    async createConundrum() {
      if (this.authUser) {
        await this.$creator.create('conundrum', this.profile);
      }
    }
  }
}
</script>

<style scoped>
.text-truncate-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style> 